import { Visibility } from '@mui/icons-material'
import React from 'react'
import { useEffect, useState } from 'react'

import VisibilityIcon from '@mui/icons-material/Visibility';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CloseIcon from '@mui/icons-material/Close';
import Modal from '@mui/material/Modal';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

export default function VignettePhotoCarousel({ article, mode }) {

    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const folderUrl = "https://www.wallyglisse.com/nestor"

    function openModal() {
        handleOpen();
        console.log("touch")
    }



    return (
        <div className="location-vignette-photo">
            <div className="location-vignette-photo-img" onClick={_ => openModal()}>
                <img src={folderUrl + "/images/photos/" + article.image_url.split(",")[0]} alt={article.description} />

                {mode === "gallery" ?
                    <div className="location-vignette-photo-icone">
                        <MoreVertIcon />
                    </div>
                    : null}
            </div>

            <Modal className="location-vignette-photo-modal"
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >



                <section className="location-vignette-photo-modal-content">

                    <div className="location-vignette-photo-modal-btclose">
                        <Button
                            onClick={_ => setOpen(false)}>
                            <CloseIcon />
                        </Button>
                    </div>


                    <Carousel // CAroussel is component from external librairy
                        // https://www.npmjs.com/package/react-multi-carousel
                        // exemples : https://react-multi-carousel.surge.sh/?selectedKind=Carousel&selectedStory=With%20infinite%20mode&full=0&addons=1&stories=1&panelRight=0&addonPanel=storybook%2Factions%2Factions-panel
                        additionalTransfrom={0}
                        arrows
                        autoPlaySpeed={3000}
                        centerMode={window.innerWidth > 800}

                        className="location-vignette-photo-carousel"
                        containerClass="container"
                        dotListClass=""
                        draggable
                        focusOnSelect={false}
                        infinite
                        itemClass=""
                        keyBoardControl
                        minimumTouchDrag={80}
                        pauseOnHover
                        renderArrowsWhenDisabled={false}
                        renderButtonGroupOutside={false}
                        renderDotsOutside={false}
                        responsive={{
                            desktop: {
                                breakpoint: {
                                    max: 3000,
                                    min: 1024
                                },
                                items: 1,
                                partialVisibilityGutter: 40
                            },
                            mobile: {
                                breakpoint: {
                                    max: 464,
                                    min: 0
                                },
                                items: 1,
                                partialVisibilityGutter: 10
                            },
                            tablet: {
                                breakpoint: {
                                    max: 1024,
                                    min: 464
                                },
                                items: 1,
                                partialVisibilityGutter: 10
                            }
                        }}
                        rewind={false}
                        rewindWithAnimation={false}
                        rtl={false}
                        shouldResetAutoplay
                        showDots={true}
                        sliderClass=""
                        slidesToSlide={1}
                        swipeable
                    >
                        {article.image_url.split(',').map((url, index) => (
                            <div key={index} className="location-vignette-photo-carousel-item">

                                <img src={folderUrl + "/images/photos/" + url} alt={article.description} />

                            </div>

                        ))}

                    </Carousel>


                </section>
            </Modal>

        </div>
    )
}
